// extracted by mini-css-extract-plugin
module.exports = {"quote-offer-container":"_1BvAXfu6H7Lf__utpqNK6H","quote-offer-list":"jIgyi-zynp751uP_w1r7W","preLoaderShimmer":"lqjGx2B3W7EIhse5OMnN_"};